/**
 * Converts seconds to MM:SS format string
 * @param seconds - The number of seconds to format
 * @returns Formatted time string in MM:SS format
 */
const generateTimerString = (seconds) => {
    let minStr = Math.floor(seconds / 60).toString();
    let secStr = Math.ceil(seconds % 60).toString();
    if (minStr.length < 2)
        minStr = `0${minStr}`;
    if (secStr.length < 2)
        secStr = `0${secStr}`;
    return `${minStr}:${secStr}`;
};
const TimerUtils = {
    generateTimerString,
};
export default TimerUtils;
